import styled from 'styled-components';
import PropTypes from 'prop-types';
import { hideOnPrint } from './helpers/mixins';

export const FullWidthContainer = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};

  ${props => props.hideOnPrint && hideOnPrint};
`;

FullWidthContainer.defaultProps = {
  bgColor: null,
  hideOnPrint: false
};

FullWidthContainer.propTypes = {
  bgColor: PropTypes.string,
  hideOnPrint: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/styles/FullWidthContainer.js